import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white p-4 mt-auto shadow-md shadow-black/40 relative border-t border-gray-700/50">
      <div className="container mx-auto text-center">
        <p className="text-gray-300">&copy; {new Date().getFullYear()} Clément Rioche. Tous droits réservés.</p>
        <div className="flex justify-center gap-4 mt-3">
          <a href="https://github.com/RiocheClement" className="hover:text-blue-300 transition-colors duration-300">GitHub</a>
          <a href="https://linkedin.com/in/clément-rioche-3694921a1" className="hover:text-blue-300 transition-colors duration-300">LinkedIn</a>
          <a href="mailto:riocheclement@gmail.com" className="hover:text-blue-300 transition-colors duration-300">Email</a>
        </div>
      </div>
      
      {/* Ajout d'une ligne d'ombre subtile au sommet du footer */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-blue-500/20 to-transparent"></div>
    </footer>
  );
};

export default Footer;
